import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { InlineIcon } from "@iconify/react";
import { useMyTimeRecordingPeriod } from "my-time/hooks";

interface MyTimePageHeaderProps {
  date: Date;
  onDateChange: (date: Date) => void;
  formattedDate: string;
  examinerPage?: boolean;
  isMobile?: boolean;
  closingperiodPage?: boolean;
}

export const MyTimePageHeader: React.FC<MyTimePageHeaderProps> = ({
  date,
  onDateChange,
  formattedDate,
  examinerPage = false,
  isMobile = false,
  closingperiodPage = false,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const changeDate = (action: string) => {
    if (action === "add") {
      onDateChange(moment(date).add(1, "month").toDate());
      return;
    }
    onDateChange(moment(date).subtract(1, "month").toDate());
  };

  const hideArrows = examinerPage || closingperiodPage;

  const { data } = useMyTimeRecordingPeriod();

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      alignItems="center"
      justifyContent="space-between"
      style={{
        backgroundColor: theme.palette.primary.main,
        height: isMobile ? "auto" : "64px",
        padding: isMobile ? "16px 16px" : "0px 16px",
        borderRadius: "8px",
      }}
    >
      <Box width={isMobile ? "100%" : "290px"}>
        <Typography
          variant="h5"
          style={{
            color: theme.palette.white.main,
          }}
        >
          {t("MY_TIME_PERIOD_TEXT")}
        </Typography>
      </Box>
      {isMobile && <Box height="16px" />}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        flexGrow={1}
        width={isMobile ? "100%" : "auto"}
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent={isMobile ? "space-between" : "center"}
          alignItems="center"
          width={isMobile ? "100%" : "auto"}
        >
          <Box paddingTop="8px">
            {!hideArrows && (
              <InlineIcon
                id="chevronLeft"
                icon="mdi:chevron-left"
                width="36px"
                height="36px"
                color="#fff"
                style={{
                  cursor: "pointer",
                  marginLeft: isMobile ? "-10px" : "0px",
                }}
                onClick={() => changeDate("subtract")}
              />
            )}
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            width="290px"
            textAlign="center"
          >
            <Typography
              variant="h4"
              style={{
                color: theme.palette.white.main,
              }}
            >
              {closingperiodPage ? data : formattedDate}
            </Typography>
          </Box>
          <Box paddingTop="8px">
            {!hideArrows && (
              <InlineIcon
                id="chevronRight"
                icon="mdi:chevron-right"
                width="36px"
                height="36px"
                color="#fff"
                style={{
                  cursor: "pointer",
                  marginRight: isMobile ? "-10px" : "0px",
                }}
                onClick={() => changeDate("add")}
              />
            )}
          </Box>
        </Box>
      </Box>
      {isMobile && <Box height="16px" />}
      {!closingperiodPage ? (
        <Box
          width={isMobile ? "auto" : "290px"}
          height="36px"
          display="flex"
          flexDirection="row"
          alignItems="center"
          padding="0px 16px"
          justifyContent="center"
          style={{
            border: "1px solid #fff",
            borderRadius: "8px",
            color: theme.palette.white.main,
          }}
        >
          <Typography color="white.main">
            {t("MY_TIME_RECORDING_PERIOD")}:
          </Typography>
          <Box width="4px" />
          <Typography color="white.main">{data}</Typography>
        </Box>
      ) : (
        <Box width="290px" />
      )}
    </Box>
  );
};

export default MyTimePageHeader;
